// extracted by mini-css-extract-plugin
module.exports = {"root":"Shift_root__37Onu","name":"Shift_name__iQz0v","droppableContainer":"Shift_droppableContainer__2xt50","draggedOver":"Shift_draggedOver__1gq--"};